/**
 * 四象限散点图 - 汇总摘要组件
 */
import React, { useMemo } from 'react';
import useLanguage from '@op/hooks/useLanguage';
import { QUADRANT_CONFIG } from '../../constants';
import type { IProcessedQuadrantItem } from '../../hooks/useQuadrantData';

interface IQuadrantSummaryProps {
  processedData: IProcessedQuadrantItem[];
}

// 按优先级显示：已发酵(2, 红色最紧急) → 情绪放大(3, 橙色高关注) → 扩散中(1, 黄色需关注)
// Q4(稳定/噪音) 不在摘要中显示
const DISPLAY_ORDER = [2, 3, 1] as const;

const QuadrantSummary: React.FC<IQuadrantSummaryProps> = ({ processedData }) => {
  const { formatMessage, isEn } = useLanguage();

  // 按象限分组话题
  const quadrantTopics = useMemo(() => {
    if (!processedData || processedData.length === 0) return null;

    const topics: Record<number, IProcessedQuadrantItem[]> = {};

    processedData.forEach((item) => {
      if (DISPLAY_ORDER.includes(item.quadrant as typeof DISPLAY_ORDER[number])) {
        if (!topics[item.quadrant]) {
          topics[item.quadrant] = [];
        }
        topics[item.quadrant].push(item);
      }
    });

    // 如果没有任何话题，返回 null
    if (Object.keys(topics).length === 0) return null;

    return topics;
  }, [processedData]);

  if (!quadrantTopics) {
    if (!processedData || processedData.length === 0) return null;
    return <span>{formatMessage({ id: 'No fermented sub-topics this week' })}</span>;
  }

  return (
    <span className="dbo-quadrant-summary">
      <span className="dbo-quadrant-summary-title">{formatMessage({ id: 'Escalating Subtopics' })}:</span>
      <span className="dbo-quadrant-summary-list">
         {DISPLAY_ORDER.map((q) => {
          const topics = quadrantTopics[q];
          if (!topics || topics.length === 0) return null;

          const config = QUADRANT_CONFIG[q];
          if (!config) return null;

          // 格式化所有子话题显示（用顿号分隔）
          const topicNames = topics.map((t) => isEn ? t.sub_category : t.sub_category_cn).join('、');

          return (
            <span key={q} className="dbo-quadrant-summary__item">
              <span
                className="dbo-quadrant-summary__label"
                style={{
                  backgroundColor: config.bgColor,
                  padding: '2px 8px',
                  borderRadius: 10,
                  // marginLeft: index > 0 ? 8 : 0,
                  // display: 'inline-flex',
                  // alignItems: 'center',
                  gap: 4,
                }}
              >
                <span style={{ color: config.labelColor, fontWeight: 500, marginRight: 6 }}>
                  {formatMessage({ id: config.name })}
                </span>
                <span style={{ color: '#262832' }}>
                  {topicNames}
                </span>
              </span>
            </span>
          );
        })}
      </span>

    </span>
  );
};

export default QuadrantSummary;
